module.exports = __webpack_public_path__ + "static/Irriglobe_G_031-8a4a45de578c3423bfdb0af6e25f29f2.jpg";